import './public-path';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './AuthContext';

let root = null;

function render(props = {}) {
  const { container } = props;
  const mountNode = container
    ? container.querySelector('#root')
    : document.querySelector('#root');

  // 默认未登录状态，将通过 onGlobalStateChange 更新
  const initialAuthState = { user: null, isAuthenticated: false };

  root = ReactDOM.createRoot(mountNode);
  root.render(
    <AuthProvider 
      initialState={initialAuthState}
      qiankunProps={props}
    >
      <App />
    </AuthProvider>
  );
}

export async function bootstrap() {
  console.log('[React 子应用] bootstrap');
}

export async function mount(props) {
  console.log('[React 子应用] mount', props);
  render(props);
}

export async function unmount() {
  console.log('[React 子应用] unmount');
  if (root) {
    root.unmount();
    root = null;
  }
}

if (!window.__POWERED_BY_QIANKUN__) {
  console.log('[React 子应用] 独立运行模式');
  render();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
